module.exports = __webpack_public_path__ + "static/media/back_arrow_white.a8b0c9fe.svg";